<template>
  <div class="list-container">
    <div class="filter-container">
        <div class="filter-box">
          <span class="label">物料类别</span>
          <el-select :filterable="true" v-model="listQuery.materialClassId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
            <el-option
              v-for="item in materialClassOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="filter-box">
            <span class="label">名称</span>
            <el-input
              v-model="listQuery.name"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
        </div>
        <div class="filter-box">
            <span class="label">品牌</span>
            <el-input
              v-model="listQuery.brand"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">型号</span>
            <el-input
              v-model="listQuery.model"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
        <div class="filter-box">
            <el-button
                v-waves
                class="filter-item "
                type="primary"
                :size="t('table.btnSize')"
                @click="handleFilter"
            >
                {{ t("table.search") }}
            </el-button>
            <el-button
              v-permission="{ pkey: `${permissionName}_ADD` }"
              class="filter-item"
              type="primary"
              :size="t('table.btnSize')"
              @click="handleCommand('add')"
            >
              {{ t("table.add") }}
            </el-button>
            <el-button
                v-waves
                class="filter-item"
                :size="t('table.btnSize')"
                @click="handleReset"
            >
                {{ t("table.reset") }}
            </el-button>
        </div>
    </div>
    <TableList
      ref="TableList"
      v-loading="listLoading"
      :dataList="list"
      :total="total"
      :page="listQuery.page"
      :size="listQuery.size"
      :columnAllData="columnAllData"
      :tableName="TableName"
      :permissionName="permissionName"
      :showSelection="true"
      :canCommand="false"
      :canChangeColumn="false"
      @command-change="handleCommand"
    >
      <template v-slot:max="scope" >
        <span>
           <el-tooltip
            effect="dark"
            placement="top-start"
            v-if="scope.row.max"
          >
            <template #content> {{scope.row.max?.supplier?.name}}<br /> 最后修改时间：{{scope.row.max?.updateTime}}</template>
            <i class="iconfont icon-tubiao-30" style="font-size:14px"/>
          </el-tooltip>
          {{ maxMinCalc(scope.row, 'max') }}
        </span>
      </template>
      <template v-slot:min="scope" >
        <span>
          <el-tooltip
            effect="dark"
            placement="top-start"
            v-if="scope.row.min"
          >
            <template #content> {{scope.row.max?.supplier?.name}}<br /> 最后修改时间：{{scope.row.min?.updateTime}}</template>
            <i class="iconfont icon-tubiao-30" style="font-size:14px"/>
          </el-tooltip>
          {{ maxMinCalc(scope.row, 'min') }}
        </span>
      </template>
    </TableList>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { cloneDeep } from 'lodash'
import { getPageList } from '@/apis/Dictionary'

import { ArrayRowsItem } from '@/model/Index'

import TableList from '@/components/common/TableList.vue'

import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { TableField, maxMinCalc } from './FieldTable'
import { pageVoTen } from '@/utils/index'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Materialinfo',
  components: {
    TableList
  },
  props: {
    excludeIds: { type: Array, required: false, default: () => [] },
    pathApi: { type: String, required: false, default: null },
    officeSupplies: { type: Boolean, required: false, default: null }
  },
  setup(props) {
    const { t } = useI18n()

    const dataMap = reactive({
      TableName: TableName.TABLE_MATERIALINFO,
      permissionName: permissionName.MATERIALINFO,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: FromFieldData,
      columnAllData: TableField.filter((kk) => kk.visible ? kk.visible(false) : true),
      pathApi: 'material',
      activeId: 0,
      maxMinCalc,
      list: [],
      selectionArray: [],
      materialClassOption: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        officeSupplies: props.officeSupplies,
        ...pageVoTen
      },
      dialogFormVisible: false,

      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'selection':
            dataMap.selectionArray = val
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        getPageList(dataMap.pathApi, { ...dataMap.listQuery, excludeIds: props.excludeIds }).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          officeSupplies: props.officeSupplies,
          ...pageVoTen
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getMaterialClassOption() {
        getPageList(props.pathApi || 'materialClass', { page: 1, size: 999 }).then((res: any) => {
          dataMap.materialClassOption = res.data || []
        })
      }
    })
    onMounted(() => {
      dataMap.getList()
      dataMap.getMaterialClassOption()
    })
    return { t, ...toRefs(dataMap) }
  }
})
</script>
<style  lang="scss">

</style>
